import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField, 
  Box 
} from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'

const EventDialog = ({
  open,
  onClose,
  onSubmit,
  entry,
  newEvent,
  setNewEvent,
  eventDate,
  setEventDate,
  isSubmitting
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>Add Event for {entry.name || `Entry ${entry.entryId.slice(0, 6)}`}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          label="Event Description"
          multiline
          rows={3}
          value={newEvent}
          onChange={(e) => setNewEvent(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          placeholder="e.g., Started molting, Acting lethargic, First crow, Broody behavior..."
          fullWidth
          variant="outlined"
          sx={{ mt: 1 }}
        />
        
        <Box sx={{ mt: 2 }}>
          <DatePicker
            label="Event Date"
            value={dayjs(eventDate)}
            onChange={(newValue) => {
              setEventDate(newValue ? newValue.format('YYYY-MM-DD') : new Date().toISOString().split('T')[0])
            }}
            maxDate={dayjs()}
            slotProps={{
              textField: {
                fullWidth: true,
                size: 'small',
                onClick: (e) => e.stopPropagation()
              }
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={onSubmit} 
          variant="contained"
          disabled={!newEvent.trim() || isSubmitting}
        >
          {isSubmitting ? 'Adding...' : 'Add Event'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EventDialog